module.exports = __webpack_public_path__ + "img/bg.62db1f3d.png";